import React from "react";
import { BrowserRouter as Router, Route, Routes,BrowserRouter } from "react-router-dom";
import { StateMachineProvider, createStore } from "little-state-machine";
import logo from './logo.svg';
import './App.css';
import Index from './pages/index'
import Tstep1 from "./pages/Tstep1";
import test from "./pages/test"
import Tstep2 from "./pages/Tstep2";
import Sstep1 from "./pages/Sstep1";
import Sstep2 from "./pages/Sstep2";
import Sstep3 from "./pages/Sstep3";
import Sstep4 from "./pages/Sstep4";
import Tfinal from "./pages/Tfinal";
import Sfinal from "./pages/Sfinal";
import Sstep5 from "./pages/Sstep5";
function App() {
  return (
    <StateMachineProvider>
      <BrowserRouter basename="/signup">
        <Routes>
          <Route path="/" element={<Index/>} />
          <Route path="/tstep1" element={<Tstep1 />} />
          <Route path="/test" element={<test />} />
          <Route path="/Tstep2" element={<Tstep2 />} />
          <Route path="/Sstep1" element={<Sstep1 />} />
          <Route path="/Sstep2" element={<Sstep2 />} />
          <Route path="/Sstep3" element={<Sstep3 />} />
          <Route path="/Sstep4" element={<Sstep4 />} />
          <Route path="/Sstep5" element={<Sstep5 />} />
          <Route path="/Tfinal" element={<Tfinal />} />
          <Route path="/Sfinal" element={<Sfinal />} />
        </Routes>
      </BrowserRouter>
    </StateMachineProvider>
  );
}

export default App;
